module.exports = __webpack_public_path__ + "static/media/rotate-icon.c4d6d950.svg";